import { render, staticRenderFns } from "./QuitaPlanForm.vue?vue&type=template&id=0df50f1b&scoped=true"
import script from "./QuitaPlanForm.vue?vue&type=script&lang=js"
export * from "./QuitaPlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df50f1b",
  null
  
)

export default component.exports